<template>
  <div>
    <base-modal
      :showing="visible && !productBoxModalVisible"
      size="max-w-6xl"
      @close="onClose"
      @opened="onOpened"
    >
      <base-card
        :with-style="false"
        title="Detail Stock"
        description="Berdasarkan data stock yang telah dibuat"
      >
        <div class="border-t pt-6">
          <dl class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-6">
            <div v-if="columns.includes('is_published')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Status Publish</dt>
              <dd class="mt-1 text-sm text-gray-900">
                <base-toggle
                  with-label
                  label-true="Publish"
                  label-false="Tidak Terpublish"
                  v-model="stock.data.attributes.is_published"
                  @change-debounce="onChangePublishedDebounce"
                />
              </dd>
            </div>
            <div v-if="columns.includes('product_code')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Kode Barang</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ stock.data.attributes.product_code }}
              </dd>
            </div>
            <div v-if="columns.includes('product_name')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Nama Barang</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ stock.data.attributes.product_name }}
              </dd>
            </div>
            <div v-if="columns.includes('unit')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Satuan</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ product ? product.attributes.unit_name : '-' }}
              </dd>
            </div>
            <div v-if="columns.includes('volume')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Isi</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ product ? product.attributes.volume : '-' }}
              </dd>
            </div>
            <div v-if="columns.includes('pv')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Point Value (PV)</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ (product ? product.attributes.point : 0) | toCurrency }}
              </dd>
            </div>
            <div v-if="columns.includes('bv')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Bonus Value (PV)</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ (product ? product.attributes.bonus : 0) | toCurrency }}
              </dd>
            </div>
            <div v-if="columns.includes('weight')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Total Berat</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ (product ? product.attributes.weight : 0) | toCurrency }}
              </dd>
            </div>
            <div v-if="columns.includes('stock')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Stok</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ stock.data.attributes.stock_real | toCurrency }}
              </dd>
            </div>
            <div v-if="columns.includes('stock_restock')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Stok Restock</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ stock.data.attributes.stock_loan_qty | toCurrency }}
              </dd>
            </div>
            <div v-if="columns.includes('stock_qty')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Stock</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ stock.data.attributes.stock_qty }}
              </dd>
            </div>
            <div v-if="columns.includes('expired_qty')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Stock Kadaluarsa</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ stock.data.attributes.expired_count }}
              </dd>
            </div>
            <div v-if="columns.includes('damaged_qty')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Stock Rusak</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ stock.data.attributes.damaged_count }}
              </dd>
            </div>
            <div
              v-if="columns.includes('suitable_for_sale_qty')"
              class="sm:col-span-2"
            >
              <dt class="text-sm font-bold text-gray-700">Stock Layak Jual</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ stock.data.attributes.suitable_for_sale_count }}
              </dd>
            </div>
            <div
              v-if="columns.includes('unsuitable_for_sale_qty')"
              class="sm:col-span-2"
            >
              <dt class="text-sm font-bold text-gray-700">
                Stock Tidak Layak Jual
              </dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ stock.data.attributes.unsuitable_for_sale_count }}
              </dd>
            </div>
            <div v-if="columns.includes('free_qty')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Stock Promo</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{ stock.data.attributes.free_qty }}
              </dd>
            </div>
            <div v-if="columns.includes('order_status')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Status Order</dt>
              <dd class="mt-1 text-sm text-gray-900">
                <base-badge
                  :color="
                    stock.data.attributes.is_orderable ? 'blue' : 'yellow'
                  "
                >
                  {{
                    stock.data.attributes.is_orderable ? 'Open' : 'Close'
                  }}</base-badge
                >
              </dd>
            </div>
            <div
              v-if="columns.includes('pre_order_status')"
              class="sm:col-span-2"
            >
              <dt class="text-sm font-bold text-gray-700">Status Pre Order</dt>
              <dd class="mt-1 text-sm text-gray-900">
                <base-badge
                  :color="
                    stock.data.attributes.is_pre_orderable ? 'blue' : 'yellow'
                  "
                >
                  {{
                    stock.data.attributes.is_pre_orderable ? 'Open' : 'Close'
                  }}</base-badge
                >
              </dd>
            </div>
            <div
              v-if="columns.includes('license_status')"
              class="sm:col-span-2"
            >
              <dt class="text-sm font-bold text-gray-700">Status Izin</dt>
              <dd class="mt-1 text-sm text-gray-900">
                <base-badge
                  :color="
                    stock.data.attributes.license_status ? 'blue' : 'yellow'
                  "
                >
                  {{
                    stock.data.attributes.license_status ? 'Open' : 'Close'
                  }}</base-badge
                >
              </dd>
            </div>
            <div
              v-if="columns.includes('distributor_price')"
              class="sm:col-span-2"
            >
              <dt class="text-sm font-bold text-gray-700">Harga Distributor</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{
                  getProductPriceByBuyerType('Mitra Usaha')?.attributes?.price
                    | toCurrency
                }}
              </dd>
            </div>
            <div
              v-if="columns.includes('stockist_price')"
              class="sm:col-span-2"
            >
              <dt class="text-sm font-bold text-gray-700">Harga Stockist</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{
                  getProductPriceByBuyerType('Stockist')?.attributes?.price
                    | toCurrency
                }}
              </dd>
            </div>
            <div
              v-if="columns.includes('consumen_price')"
              class="sm:col-span-2"
            >
              <dt class="text-sm font-bold text-gray-700">Harga Konsumen</dt>
              <dd class="mt-1 text-sm text-gray-900">
                {{
                  getProductPriceByBuyerType('Konsumen')?.attributes?.price
                    | toCurrency
                }}
              </dd>
            </div>
            <div v-if="columns.includes('qrcode')" class="sm:col-span-2">
              <dt class="text-sm font-bold text-gray-700">Kode QR</dt>
              <dd v-if="product" class="mt-1 text-sm text-gray-900">
                <div class="grid grid-cols-2 gap-2">
                  <div class="flex items-center gap-2">
                    <span>QR Piece</span>
                    <button @click="onDownloadQr">
                      <Icon
                        icon="heroicons:arrow-down-tray"
                        class="h-4 w-4 text-green-600"
                      />
                    </button>
                  </div>
                  <a
                    href=""
                    class="font-medium text-yellow-600 hover:text-yellow-500"
                    @click.prevent="onViewQrBox"
                    >Daftar QR Box</a
                  >
                  <div ref="qrcode">
                    <qr-code
                      v-if="product.attributes.qrcode"
                      :text="product.attributes.qrcode"
                      :size="150"
                    />
                  </div>
                  <div
                    v-if="downloadingQrCode"
                    class="flex flex-col justify-center p-4"
                    ref="donwloadqrcode"
                  ></div>
                  <p v-if="!product.attributes.has_boxes">Tidak ada box</p>
                  <ul v-else class="list-inside list-disc">
                    <li
                      v-for="name in productBoxesName"
                      :key="name"
                      class="text-sm"
                    >
                      {{ name }}
                    </li>
                  </ul>
                </div>
              </dd>
            </div>
            <div v-if="withOrdered" class="sm:col-span-6">
              <dt class="text-sm font-bold text-gray-700 mb-2">Stok Diorder</dt>
              <StockOrderDetail :stock-id="stockId" />
            </div>
            <div v-if="withBonusOrdered" class="sm:col-span-6">
              <dt class="text-sm font-bold text-gray-700 mb-2">Bonus Diorder</dt>
              <StockOrderDetailBonus :stock-id="stockId" />
            </div>
            <div class="sm:col-span-6">
              <div class="flex items-center justify-between">
                <div class="flex items-center gap-2">
                  <base-select
                    size="sm"
                    :shadow="false"
                    :options="[
                      {
                        key: 'history',
                        label: 'Riwayat Stock',
                        value: 'history',
                      },
                      {
                        key: 'history_free',
                        label: 'Riwayat Stock Free',
                        value: 'history_free',
                      },
                      { key: 'batch', label: 'Daftar Batch', value: 'batch' },
                    ]"
                    v-model="mode"
                    @change="onChangeMode"
                  />
                  <keep-alive>
                    <period-select
                      v-if="mode === 'history' || mode === 'history_free'"
                      dropdown
                      v-model="filterHistories.period_uuid"
                      @change="loadStockHistories"
                    />
                  </keep-alive>
                </div>
                <keep-alive>
                  <div v-if="mode === 'history' || mode === 'history_free'" class="flex gap-8">
                    <p class="text-sm text-gray-700">Stock Awal</p>
                    <p class="text-sm font-bold text-gray-900">
                      {{ stockHistories.meta.last_period_stock | toCurrency }}
                    </p>
                  </div>
                </keep-alive>
              </div>
              <dd class="mt-3">
                <keep-alive>
                  <stock-history-table
                    v-if="mode === 'history' || mode === 'history_free'"
                    :data="stockHistories"
                    :extra-columns="['batch_code']"
                    @change-page="onChangePageHistory"
                  />
                  <stock-batch-table
                    v-else
                    :product-id="product.id"
                    @update-loading="(val) => (loadingStockBatch = val)"
                  />
                </keep-alive>
              </dd>
            </div>
          </dl>
        </div>
      </base-card>
    </base-modal>

    <view-product-box-modal
      v-if="product"
      :product-id="product.id"
      :product-code="product.attributes.code"
      :visible="productBoxModalVisible"
      :with-action="false"
      @close="productBoxModalVisible = false"
    />

    <loading v-if="loading" />
  </div>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import BaseModal from '@/components/base/BaseModal.vue';
import StockHistoryTable from './stock-history-table.vue';
import StockBatchTable from './stock-batch-table.vue';
import PeriodSelect from '@/components/period/period-select.vue';
import ViewProductBoxModal from '@/components/product/view-product-box-modal.vue';
import BaseToggle from '@/components/base/BaseToggle.vue';
import QrCode from 'vue-qrcode-component';
import html2canvas from 'html2canvas';
import { nextTick } from 'vue';
import { mapGetters } from 'vuex';
import StockOrderDetailBonus from './stock-order-detail-bonus.vue';
import StockOrderDetail from './stock-order-detail.vue';

export default {
  mixins: [requestMixin],
  components: {
    BaseModal,
    StockHistoryTable,
    PeriodSelect,
    QrCode,
    ViewProductBoxModal,
    StockBatchTable,
    BaseToggle,
    StockOrderDetailBonus,
    StockOrderDetail
  },
  props: {
    visible: Boolean,
    stockId: String,
    withBonusOrdered: Boolean,
    withOrdered: Boolean,
    columns: {
      type: Array,
      default: () => [
        'product_code',
        'product_name',
        'unit',
        'volume',
        'pv',
        'bv',
        'weight',
        'stock',
        'stock_restock',
        'order_status',
        'pre_order_status',
        'distributor_price',
        'stockist_price',
        'consumen_price',
      ],
    },
  },
  emits: ['close'],
  data() {
    return {
      downloadingQrCode: false,
      mode: 'history',
      filterHistories: {
        period_uuid: null,
      },
      loadingStock: false,
      loadingStockHistory: false,
      loadingProductPrice: false,
      loadingStockBatch: false,
      loadingUpdatePublished: false,
      stock: {
        data: {
          attributes: {},
          relationships: {
            product: {
              data: {},
            },
          },
        },
        included: [],
      },
      productPrices: {
        data: [],
      },
      productBoxesName: [],
      stockHistories: {
        data: [],
        meta: {
          page: {},
        },
      },
      productBoxModalVisible: false,
      reload: true,
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser'
    }),
    loading() {
      return (
        this.loadingStock ||
        this.loadingStockHistory ||
        this.loadingProductPrice ||
        this.loadingStockBatch ||
        this.loadingUpdatePublished
      );
    },
    product() {
      return this.getSingleIncluded(
        this.stock,
        this.stock.data.relationships.product.data.id
      );
    },
  },
  methods: {
    getProductPriceByBuyerType(buyerType) {
      return this.productPrices.data.find(
        (productPrice) => productPrice.attributes['buyer-type'] === buyerType
      );
    },
    async loadCurrentPeriod() {
      const [res, err] = await this.request(
        '/api/v1/periods/-actions/get-current-period'
      );

      if (!err) {
        this.filterHistories.period_uuid = res.data.id;
      }
    },
    async loadProductPrices() {
      this.loadingProductPrice = true;

      const [res, err] = await this.request(
        `/api/v1/products/${this.product.id}/product-prices`,
        {
          params: {
            'fields[product-prices]': 'buyer-type,price',
            'filter[buyer-type-in]': 'Stockist,Konsumen,Mitra Usaha',
            'filter[area_code]': this.me.office_area_code
          },
        }
      );

      if (!err) {
        this.productPrices = res;
      }

      this.loadingProductPrice = false;
    },
    async loadStockHistories(params) {
      this.loadingStockHistory = true;

      const [res, err] = await this.request(
        `/api/v1/stocks/${this.stock.data.id}/stock-trxes`,
        {
          params: {
            'page[size]': 5,
            sort: 'latest',
            'fields[stock-trxes]':
              'createdAt,amount,type,current_stock,description,batch_code',
            'filter[period_uuid]': this.filterHistories.period_uuid,
            'filter[stock_type]': this.mode === 'history' ? 'reguler' : 'free',
            ...params,
          },
        }
      );

      if (!err) {
        this.stockHistories = res;
      }

      this.loadingStockHistory = false;
    },
    async loadProduxtBoxes() {
      const [res, err] = await this.request(
        `/api/v1/products/${this.product.id}/product-boxes`,
        {
          params: {
            'page[size]': 5,
            'fields[products]': 'name',
            sort: '-createdAt',
          },
        }
      );

      if (!err) {
        this.productBoxesName = res.data.map((item) => item.attributes.name);
      }
    },
    onChangeMode() {
      if (this.mode === 'history' || this.mode === 'history_free') {
        this.loadStockHistories()
      }
    },
    onChangePageHistory(page) {
      this.loadStockHistories({
        'page[number]': page,
      });
    },
    onClose() {
      this.reload = true;
      this.$emit('close');
    },
    async onOpened() {
      if (this.reload) {
        this.mode = 'history';
        this.loadingStock = true;

        const [res, err] = await this.request(
          `/api/v1/stocks/${this.stockId}`,
          {
            params: {
              include: 'product.product-prices',
              'fields[stocks]':
                'product_code,product_name,stock_real,stock_loan_qty,product,is_orderable,is_pre_orderable,stock_qty,free_qty,expired_count,damaged_count,suitable_for_sale_count,unsuitable_for_sale_count,is_published',
              'fields[products]':
                'code,qrcode,unit_name,volume,point,bonus,weight,supplier_price,has_boxes',
            },
          }
        );

        if (!err) {
          this.stock = res;

          this.loadProductPrices();
          this.loadStockHistories();

          if (this.product.attributes.has_boxes) {
            await this.loadProduxtBoxes();
          } else {
            this.productBoxesName = [];
          }
        }

        this.loadingStock = false;
      }
    },
    async onDownloadQr() {
      this.downloadingQrCode = true;

      await nextTick();

      const qrcodeImage = this.$refs.qrcode
        .querySelector('img')
        .cloneNode(true);
      const donwloadqrcodeEl = this.$refs.donwloadqrcode;

      const qrcodeText = document.createElement('p');
      qrcodeText.style.textAlign = 'center';
      qrcodeText.textContent = this.product.attributes.code;

      donwloadqrcodeEl.appendChild(qrcodeImage);
      donwloadqrcodeEl.append(qrcodeText);

      const canvas = await html2canvas(donwloadqrcodeEl);

      canvas.toBlob((blob) => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download = `${this.product.attributes.qrcode}`;

        document.body.appendChild(link);

        link.dispatchEvent(new MouseEvent('click'));

        document.body.removeChild(link);

        this.downloadingQrCode = false;
      });
    },
    onViewQrBox() {
      this.productBoxModalVisible = true;
      this.reload = false;
    },
    async onChangePublishedDebounce() {
      this.loadingUpdatePublished = true;

      await this.request(`/api/v1/stocks/${this.stock.data.id}`, {
        method: 'patch',
        data: {
          data: {
            id: this.stock.data.id,
            type: 'stocks',
            attributes: {
              is_published: this.stock.data.attributes.is_published,
            },
          },
        },
      });

      this.loadingUpdatePublished = false;
    },
  },
  created() {
    this.loadCurrentPeriod();
  },
};
</script>
